import { createContext, useContext, useReducer } from 'react';
import {
  ACTION_TYPES,
  initialState,
  PublicationDetailReducer,
  PublicationDetailState,
  PublicationDetailAction,
} from './publication-detail-reducer';

const PublicationDetailContext = createContext<PublicationDetailState | undefined>(undefined);
const PublicationDetailDispatchContext = createContext<React.Dispatch<PublicationDetailAction> | undefined>(undefined);

export const PublicationDetailProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(PublicationDetailReducer, initialState);

  return (
    <PublicationDetailContext.Provider value={state}>
      <PublicationDetailDispatchContext.Provider value={dispatch}>
        {children}
      </PublicationDetailDispatchContext.Provider>
    </PublicationDetailContext.Provider>
  );
};

export const usePublicationDetailState = () => {
  const context = useContext(PublicationDetailContext);
  if (context === undefined) {
    throw new Error('usePublicationDetailState must be used within a PublicationDetailProvider');
  }
  return context;
};

export const usePublicationDetailDispatch = () => {
  const context = useContext(PublicationDetailDispatchContext);
  if (context === undefined) {
    throw new Error('usePublicationDetailDispatch must be used within a PublicationDetailProvider');
  }
  return context;
};

export { ACTION_TYPES };
